<template>
  <div class="container">
    <div class="columns">
      <div class="column is-half is-offset-one-quarter has-text-centered">
        <span class="mdi mdi-account-circle mdi-72px" />
        <b-notification
          type="is-light"
          aria-close-label="Close notification"
          role="alert"
          :closable="false"
        >
          <div class="columns">
            <div class="column is-3 is-flex">
              <span class="has-text-danger is-align-self-center">
                <i class="fas fa-ban fa-7x"></i>
              </span>
            </div>
            <div class="column">
              <span class="is-size-4 has-text-weight-bold"
                >Usuario no est&aacute; autorizado</span
              >
              <dl>
                <dt>Usuario</dt>
                <dd>{{ sesion.nombreUsuario }}</dd>
                <dt>Nombre</dt>
                <dd>{{ sesion.nombre }}</dd>
              </dl>
              <strong>
                Debe contactarse con el encargado de MOPI en su bodega
              </strong>
            </div>
          </div>
        </b-notification>
      </div>
    </div>
  </div>
</template>

<script>
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faBan } from '@fortawesome/free-solid-svg-icons'

import { mapGetters } from 'vuex'
export default {
  name: 'UsuarioNoAutorizado',
  computed: {
    ...mapGetters('sesion', ['sesion'])
  },
  mounted() {
    library.add(faBan)
    dom.watch()
  }
}
</script>
<style lang="scss" scoped>
.container {
  margin-top: 30px;
}
.mdi-72px {
  font-size: 72px;
  :before {
    font-size: 72px;
  }
}
</style>
